<template>
  <v-dialog
      :value="value"
      max-width="600px"
      @keydown.esc="$emit('input', false)"
      @click:outside="$emit('input', false)"
  >
    <v-card>
      <v-card-title class="primary white--text pa-2">
        Kontakt zum Fachbereich
      </v-card-title>
      <v-container class="title">
        <p><strong>{{items[0].text}}</strong></p>
        <p><v-icon v-text="items[1].icon" color="primary"></v-icon> <span class="tab">{{items[1].text}}</span></p>
        <p><v-icon v-text="items[2].icon" color="primary"></v-icon> <span class="tab">{{items[2].text}}</span></p>
        <p><v-icon v-text="items[3].icon" color="primary"></v-icon> <span class="tab">{{items[3].text}}</span></p>
      </v-container>
      <v-container>

      </v-container>
      <v-card-actions>
        <v-btn
            block
            color="primary"
            outlined
            small
            @click="$emit('input', false)"
        >
          Schließen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogKontakt',

  data: () => {
    return {
      items: [
        {
          icon: '',
          text: 'Sie erreichen uns über:',
        },
        {
          icon: 'phone',
          text: '+49 461 316-1411',
        },
        {
          icon: 'print',
          text: '+49 461 316-272803',
        },
        {
          icon: 'mail',
          text: 'htyp-wmi@kba.de',
        },
      ],
    }
  },

  props: {
    value: Boolean,
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped>

</style>
